export const dataSource_tonghao = [
  { key: '-1', title: '推荐' },
  { key: '0', title: '笔墨点亮生活' },
  { key: '1', title: '好作业' },
  { key: '2', title: '学习感悟' },
  { key: '3', title: '回后山' },
  { key: '4', title: '小食光' },
  { key: '5', title: '暄桐雅会' },
  { key: '6', title: '桐学雅会' },
  { key: '7', title: '桐学作品' }
]

export const dataSource_tonghao2 = [
  { key: '0', title: '关注' },
  { key: '1', title: '推荐' }
]
